export const model = {
  global: {
    tabClassName: "mytab",
    tabSetEnableMaximize: false,
    tabSetClassNameTabStrip: "mytabstrip",
  },
  borders: [],
  layout: {
    type: "row",
    id: "#c4f61be1-a9fd-46a5-9104-cdf174667540",
    children: [
      {
        type: "row",
        id: "#82c018a6-7454-4f2d-901f-b1153dcb61a9",
        children: [
          {
            type: "tabset",
            id: "#a6ceb3db-a5c0-40a6-9058-acddaece22b97x",
            weight: 4.891304347826087,
            tabStripHeight: 6,
            children: [
              {
                type: "tab",
                id: "#d7203016-ec93-4600-852a-62add41b5881ccx",
                name: "",
                component: "Header",
                enableClose: false,
                enableFloat: false,
              },
            ],
            active: true,
          },
          {
            type: "tabset",
            id: "#a6ceb3db-a5c0-40a6-9058-acdaece22b97x",
            weight: 4.891304347826087,
            tabStripHeight: 6,
            children: [
              {
                type: "tab",
                id: "#d7203016-ec93-4600-852a-62ad41b5881ccx",
                name: "",
                component: "Controls",
                enableClose: false,
                enableFloat: false,
              },
            ],
            active: true,
          },
          {
            type: "tabset",
            id: "#a6ceb3db-a5c0-40a6-9058-acdaece22b97",
            weight: 95.1086956521739,
            tabStripHeight: 6,
            children: [
              {
                type: "tab",
                id: "#d7203016-ec93-4600-852a-62ad41b5881cc",
                name: "",
                component: "TableView",
                enableClose: false,
                enableFloat: false,
              },
            ],
          },
        ],
      },
    ],
  },
};
